const Procedures = () => import('@/pages/settings/procedures/ListProcedures.vue');
const ProceduresDoctor = () => import('@/pages/settings/proceduresDoctor/ProceduresDoctor.vue');
const ProductServiceAttribute = () =>
    import('@/pages/settings/productServiceAttribute/ProductServiceAttributes.vue');
const SaleProducts = () => import('@/pages/settings/saleProducts/SaleProducts.vue');
const AddEditPaymentMethod = () =>
    import('@/pages/settings/paymentMethod/AddEditPaymentMethod.vue');
const PaymentsMethods = () => import('@/pages/settings/paymentMethod/PaymentsMethods.vue');
import configRoutes from '@/routes/configuration.routes';
import { RouterView } from 'vue-router';
const ConsentTemplateManagement = () =>
    import('@/pages/clientProfile/ConsentTemplates/ConsentTemplateManagement.vue');
const ListEmployeeFormTemplates = () =>
    import('@/pages/humanResources/employeeFormTemplates/ListEmployeeFormTemplates.vue');
const AppointmentServices = () =>
    import('@/pages/settings/appointmentService/AppointmentServices.vue');
const NotificationSettings = () =>
    import('@/pages/settings/notificationSettings/NotificationSettings.vue');

const settingsRoutes = [
    {
        path: 'settings',
        name: 'Settings',
        redirect: (_to) => {
            return { path: '/settings/procedures' };
        },
        component: RouterView,
        meta: {
            title: 'Settings',
            public: false,
            icon: 'CogIcon',
        },
        children: [
            ...configRoutes,
            {
                path: 'procedures',
                name: 'SettingsProcedures',
                component: Procedures,
                meta: {
                    menu: true,
                    title: 'Procedures',
                    permissionsAnyOf: ['Permissions.Setting.Procedure.Search'],
                },
            },
            {
                path: 'doctor-procedures',
                name: 'SettingsProceduresDoctor',
                component: ProceduresDoctor,
                meta: {
                    menu: true,
                    title: 'Doctors & Procedures',
                    permissionsAnyOf: ['Permissions.Setting.ProceduresDoctor.Search'],
                },
            },
            {
                path: 'product-service-attributes',
                name: 'SettingsProductServiceAttribute',
                component: ProductServiceAttribute,
                meta: {
                    menu: true,
                    title: 'Products Attributes',
                    permissionsAnyOf: ['Permissions.Setting.ProductServiceAttribute.Search'],
                },
            },
            {
                path: 'sale-product-service',
                name: 'SettingsSaleProducts',
                component: SaleProducts,
                meta: {
                    menu: true,
                    title: 'Sale Products',
                    permissionsAnyOf: ['Permissions.Setting.SaleProductService.Search'],
                },
            },
            {
                path: 'payments-methods',
                name: 'PaymentMethod',
                component: PaymentsMethods,
                meta: {
                    menu: true,
                    title: 'Payments Methods',
                    permissionsAnyOf: ['Permissions.Setting.PaymentMethod.Search'],
                },
            },
            {
                path: 'payments-methods/add',
                name: 'AddEditPaymentMethod',
                component: AddEditPaymentMethod,
            },
            {
                path: 'consents',
                name: 'ConsentTemplates',
                component: ConsentTemplateManagement,
                meta: {
                    menu: true,
                    title: 'Consent Templates',
                    permissionsAnyOf: ['Permissions.ClientProfile.Consent.Search'],
                },
            },
            {
                path: 'employeeform-templates',
                name: 'EmployeeFormTemplates',
                component: ListEmployeeFormTemplates,
                meta: {
                    menu: true,
                    title: 'EmployeeForm Templates',
                    permissionsAnyOf: ['Permissions.HumanResources.EmployeeFormTemplate.Search'],
                },
            },
            {
                path: 'appointment-services',
                name: 'AppointmentServices',
                component: AppointmentServices,
                meta: {
                    menu: true,
                    title: 'Appointment Services',
                    permissionsAnyOf: ['Permissions.Setting.AppointmentServices.Search'],
                },
            },
            {
                path: 'notification-settings',
                name: 'NotificationSettings',
                component: NotificationSettings,
                meta: {
                    menu: true,
                    title: 'Notification Settings',
                    permissionsAnyOf: ['Permissions.Setting.NotificationSetting.View'],
                },
            },
        ],
    },
];

export default settingsRoutes;
